import { type Commands } from '../../../core/context/commands';
import { type ScopeData } from './dto';
import { Scope } from './entity';
import { Scopes } from './repository';

export class ScopeCommands implements Commands<Scopes, Scope, ScopeData> {
    addAll(repo: Scopes, data: ScopeData[]): Scopes {
        data.forEach((scope) => this.add(repo, scope));
        return repo;
    }

    add(repo: Scopes, data: ScopeData): Scopes {
        const scope = new Scope({ ...data });
        repo.add(scope);
        return repo;
    }

    update(repo: Scopes, entity: Scope): Scope {
        repo.update(entity);
        return entity;
    }

    remove(repo: Scopes, id: string): void {
        repo.remove(id);
    }

    create(repo: Scopes, data: Omit<ScopeData, 'id'>): Scope {
        const scope = Scope.new(data);
        repo.add(scope);
        return scope;
    }

    fromJSON(entity: Scope[], changeCallback: () => void): Scopes {
        const scopes = new Scopes(changeCallback);
        entity.forEach((scope) => {
            scopes.add(new Scope({ ...scope }));
        });
        return scopes;
    }
}
